<template>

    <div class="lc_root TQ_width_100p TQ_text_capitalize TQ_bg_white TQ_center ">

        <router-link
                v-for="(tab, index) in p_nabBarTabs_ac"
                :key="index"
                class="lc_tab TQ_padding_2px_0 TQ_inline TQ_noLink_link TQ_textColor_purple"
                :to="route_addLangToPath_s(tab.path)"
                :style="{'width' : 'calc( 100% / ' + p_nabBarTabs_ac.length + ' )'}"
                :class="{
                'TQ_bg_purple TQ_textColor_white TQ_text_bold' : m_sameRoute_fb(tab.path),
                'lc_tablet' : p_screenSize_en > enum_screenSizesOptions_n.mobile,
                'lc_mobile' : p_screenSize_en === enum_screenSizesOptions_n.mobile
                }">
            <div :class="{'TQ_Animation_smallBigSmall' : m_sameRoute_fb(tab.path)}">
                <tq-beacon :p_show-beacon_b="tab.showBeacon_b && !m_sameRoute_fb(tab.path)">
                    <notification-container
                        :num="tab.notification_n"
                        :show="tab.notification_n > 0">
                        <tq-image v-show="m_sameRoute_fb(tab.path)" :pb_src_r="tab.selectedImg"/>
                        <tq-image v-show="!m_sameRoute_fb(tab.path)" :pb_src_r="tab.img"/>
                    </notification-container>
                </tq-beacon>

                <div >
                    {{tab.name_byLangCode[[p_system_langCode_e]]}}
                </div>

            </div>



        </router-link>

    </div>
</template>

<script>
    import {navBar_getNavigationTabs_f} from "../../assets/scripts/Ass_NavTabs";
    import {enum_screenSizesOptions_n} from "../../../functions/src/shareCode/Share_S_Enum";
    import {ass_strings} from "../../../functions/src/shareCode/Share_Ass_Dictionary";
    import {route_addLangToPath_s, route_currentPath_s, route_moveToRoute} from "../../router";
    import NotificationContainer from "../../components/basic/TqNotificationContainer";
    import {validator_enum_fb} from "../../../functions/src/shareCode/Share_S_Validator";
    import { FB_UserData} from "../../../functions/src/shareCode/Share_S_Classes";
    import {enum_langCodes, enum_moveToOptions} from "../../../functions/src/shareCode/Share_S_Enum";
    import TqBeacon from "../../components/basic2/TqBeacon";
    import TqLink from "@/components/basic/TqLink";
    import TqImage from "@/components/basic/TqImage";

    export default {
        name: "C_App_BottomBarMobile",
        components: {TqImage, TqLink, TqBeacon, NotificationContainer},
        props:{
            p_currentUserData_c:{
                Type: FB_UserData,
                require:true
            },
            p_nabBarTabs_ac:{
                Type: Array,
                require:true
            },
            p_system_langCode_e:{
                Type: String,
                require:true,
                validator(val){
                    return validator_enum_fb(enum_langCodes, val)
                }
            },
            p_screenSize_en:{
                Type: Number,
                require:true,
                validator(val){
                    return validator_enum_fb(enum_screenSizesOptions_n, val)
                }
            }
        },
        data(){
            return {
                ass_strings: ass_strings,
                enum_screenSizesOptions_n : enum_screenSizesOptions_n,
                enum_moveToOptions : enum_moveToOptions,
                route_addLangToPath_s:route_addLangToPath_s
            }
        },
        methods:{
            m_sameRoute_fb(route_s){

                switch(route_s){

                    case enum_moveToOptions.root:
                        let currentPath = route_currentPath_s(this.$route)

                        return currentPath === route_addLangToPath_s(enum_moveToOptions.root)
                            || currentPath + "/" === route_addLangToPath_s(enum_moveToOptions.root)
                            || currentPath.includes(route_addLangToPath_s(enum_moveToOptions.root_sub))

                    default:
                        return this.$route.path.includes(route_s)
                }
            }
        },

    }
</script>

<style scoped lang="scss">


    .lc_root{

        .lc_tab{
            height: 100%;
        }
    }

    .lc_tablet{
        font-size: 16px;

        img{
            padding-top: 4px;
            width: 28px;
            margin-bottom: -2px;
        }
    }

    .lc_mobile{
        font-size: 14px;
        img{
            padding-top: 4px;
            width: 22px;
            margin-bottom: -2px;
        }
    }


    .lc_selectedTab{
        font-weight: bold;
        //background: var(--color-purple);
        color: var(--color-purple);
    }







</style>